import prettyBytes from 'pretty-bytes';
import { RequestsWidget } from '@ankr.com/telemetry';

import { RequestsWidgetPlaceholder } from 'modules/stats/components/RequestsWidgetPlaceholder';
import { getRequestsChartTranslations } from 'modules/stats/utils/getRequestsChartTranslations';
import { useAuth } from 'modules/auth/hooks/useAuth';
import { useTimeframe } from 'modules/chains/components/TimeframeProvider';
import { useTranslation } from 'modules/i18n/hooks/useTranslation';

import { WidgetSection } from '../WidgetSection';
import { trafficChartTranslation } from './translation';
import { useStats } from '../StatsProvider';
import { useTrafficChartStyles } from './useTrafficCharStyles';

export const TrafficChart = () => {
  const { isLoggingIn } = useAuth();
  const { loading, trafficChartData } = useStats();
  const { timeframe } = useTimeframe();

  const { keys, t } = useTranslation(trafficChartTranslation);
  const { classes } = useTrafficChartStyles();

  return (
    <WidgetSection title={t(keys.title)}>
      <RequestsWidget
        NoDataPlaceholder={RequestsWidgetPlaceholder}
        className={classes.root}
        data={trafficChartData}
        isLoading={loading || isLoggingIn}
        isTitleHidden
        timeframe={timeframe}
        translation={{
          ...getRequestsChartTranslations(),
          number: value => prettyBytes(Number(value)),
          callsCount: value => prettyBytes(value),
        }}
      />
    </WidgetSection>
  );
};
